<script lang="ts">
  type Props = {
    id?: string;
    message?: string | null;
  };

  let { id, message = null }: Props = $props();
</script>

{#if message}
  <p
    {id}
    class="mt-1 text-xs text-(--surface-danger)"
    role="alert"
  >
    {message}
  </p>
{/if}
